<template>
  <div class="target-item" 
    :class="[
      {
        active: active,
        fail: successKey != null && !item[successKey]
      }
    ]" 
    :style="style"
  >
  </div>
</template>

<script>
export default {
  props: [
    'item',
    'imageDimensions',
    'active',
    'successKey'
  ],
  created() {
    console.log(this.item)
  },
  computed: {
    style() {
      const imgWidth = this.imageDimensions.width
      const imgHeight = this.imageDimensions.height

      const width = (this.item.location.width ? this.item.location.width : this.item.location.height)/imgWidth * 100
      const height = this.item.location.height/imgHeight * 100

      const top = this.item.location.top/imgHeight * 100
      const left = this.item.location.left/imgWidth * 100

      return `
        width: ${width}%;
        height: ${height}%;
        top: ${top}%;
        left: ${left}%;
      `

    } 
  }
}
</script>

<style lang="scss" scoped>

.target-item {
  position: absolute;
  border: 2px solid #13bf88;
  &.fail {
    border-color: #FC692A;
  }
  &.active {
    animation: glow infinite alternate-reverse 0.5s linear
  }
}

@keyframes glow {
  0% {
    background-color: rgba(255, 255, 255, 0.0);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.5);
  }
}

</style>